<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import DeviceInfo from '@/modules/util/deviceInfo'
  import { isPhoneGap } from '@/modules/util/util'
  import imageUrl from '@/css/images/user-icon.svg'
  var intervalTimer ;
  export default {
    computed: {
      ...mapGetters([
        "AppConfig",
        'MainMenuLayout',
        'resource',
        'language',
        'ChatsUser'
      ]),
      MediaUrlCamera() {
        return this.AppConfig.Urls.ContentBaseUrl + '/.system/app_icons/outlined/35-photos-images/camera-2.svg'
      },
      MediaUrlPhotoLib() {
        return this.AppConfig.Urls.ContentBaseUrl + '/.system/app_icons/outlined/35-photos-images/picture-1.svg'
      },
      MediaUrlBin() {
        return this.AppConfig.Urls.ContentBaseUrl + '/.system/app_icons/outlined/01-content-edition/bin-1.svg'
      },
      UserName: {
        get() {
          return this.ChatsUser.userName
        },
        set(value) {
          this.updateUserData({userName: value})
        }
      },
      UserEmail: {
        get() {
          return this.ChatsUser.userEmail
        },
        set(value) {
          this.updateUserData({userEmail: value})
        }
      },
      UserImage: {
        get() {
          return this.ChatsUser.userImage
        },
        set(value) {
          this.updateUserData({userImage: value})
        }
      }
    },
    watch: {
      UserName (val) {
        this.currentUserName = val
      },
      UserEmail (val) {
        this.currentUserEmail = val
      },
      UserImage (val) {
        this.currentUserImage = val
      }
    },
    data() {
      return {
       actionGridOpened: false,
       counter: 60,
       UserCode: null,
       UserToVerify:[],
       ResponseData:[],
       isRegistred: false,
       Emaildisable:false,
       sentcode: false,
       codeToVerify: 0,
       imgHeight: 0,
       imgWeight:0,
       dataURL: "",
       inputDisabled: false,
       uploadedbase64: "",
       counterFun: null,
       currentUserName: '',
       currentUserEmail: '',
       currentUserImage: '',
       isLogin: false,
       timeLeft: '00:00',
       endTime: '0',
       times: 
        {
          sec: 300
        }
      }
    },
    beforeDestroy() {
    this.inputDisabled = false
    },
    methods: {
      ...mapActions([
        'setUserInfo',
        'galleyImageUpload',
        'getVerificationCode',
        'updateUserData',
        'insertUser',
        'showLoader',
        'hideLoader',
        'checkEmailExists',
      ]),
      setTime(seconds) {
        clearInterval(intervalTimer);
        this.timeLeft = '00:00'
        this.timer(seconds);
      },
      timer(seconds) {
        const now = Date.now();
        const end = now + seconds * 1000;
        this.displayTimeLeft(seconds);

        this.selectedTime = seconds;
        // this.initialTime = seconds;
        this.displayEndTime(end);
        this.countdown(end);
      },
      countdown(end) {
        // this.initialTime = this.selectedTime;
        intervalTimer = setInterval(() => {
          const secondsLeft = Math.round((end - Date.now()) / 1000);
          if(secondsLeft === 0) {
            this.endTime = 0;
          }
          if(secondsLeft < 0) {
            this.timeLeft = this.resource.resendBtn
            this.inputDisabled = true //if i is 0, then stop the interval
            clearInterval(intervalTimer);
            return;
          }
          this.displayTimeLeft(secondsLeft)
        }, 1000);
      },
      displayTimeLeft(secondsLeft) {
        const minutes = Math.floor((secondsLeft % 3600) / 60);
        const seconds = secondsLeft % 60; 
        this.timeLeft = `${zeroPadded(minutes)}:${zeroPadded(seconds)}`;
      },
      displayEndTime(timestamp) {
        const end = new Date(timestamp);
        const hour = end.getHours();
        const minutes = end.getMinutes();

        this.endTime = `${hourConvert(hour)}:${zeroPadded(minutes)}`
      },
      // countDown: function () {
      //   this.counter = 60
      //   if(this.counterFun)
      //     clearInterval(this.counterFun); 
      //   let that = this
      //   this.counterFun = setInterval(function () {
      //     let $displayDiv = document.getElementById("displayDiv")
      //     if ($displayDiv) {
      //       $displayDiv.innerHTML = that.counter;
      //       if (that.counter === 0) {
      //        if(that.counterFun)
      //          clearInterval(that.counterFun); 
      //        $displayDiv.innerHTML = that.resource.resendBtn
      //        that.inputDisabled = true //if i is 0, then stop the interval
      //        that.sentcode = false
      //       }  
      //       that.counter--
      //      }  
      //   }, 1000);
      // },
      getStyle: function(value) {
        if (!Helper.IsNullOrEmpty(value)) {
          return value 
        } else {
          return imageUrl
        }
      },
      getPicture(source) {
        if (!isPhoneGap()) {
          this.showAlert(this.resource.warning, this.resource.uploadImgWarning, false)
          return
        } else {
          Helper.getPictureReg(source, this)
        }
      },
      async uploadImage(dataURL, height, width) {
        let payload = {
         "ImageBase64Data": dataURL,
         "Width": width,
         "Height": height,
         "Extension":"jpeg",
         "Subscription_GUID": this.$store.getters.AppConfig.Subscription_GUID,
         "IsContent":true
        }
        let response = await this.galleyImageUpload(payload)
        if (typeof(response) !== 'undefined' ) {
          this.UserImage = response.ImageName
          this.updateUserData({userImage: response.ImageName})
        }
        return response
      },
      async ResendCode() {
        // this.countDown()
        this.setTime(this.times.sec)
        this.inputDisabled = false
        this.getCode()
      },
      removeImage() {
        this.currentUserImage = ''
        this.resetImgVariables()
        return this.getStyle('')
      },
      async login() {
        this.isLogin = true
        if (Helper.IsUserActionAllow()) {
          //this.countDown()
          this.setTime(this.times.sec)
          let message = this.getEmailValidationMsg()
          if (message !== '') {
            this.showAlert(this.resource.errorCommentTitle, message, false)
          } else {
            await this.getCode()
          }
        }
      },
      async register() {
        this.isLogin = false
        if (Helper.IsUserActionAllow()) {
          //this.countDown()
          this.setTime(this.times.sec)
          let message = this.getValidationMsg()
          if (message !== '') {
            this.showAlert(this.resource.errorCommentTitle, message, false)
          } else {
           this.getCode()
          }
        } else {
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid
              ? this.resource.AndroidDownload
              : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      },
      showAlert (title, subtitle, isSuccess) {
        this.$f7.notification.create({
          title: title,
          subtitle: subtitle,
          cssClass: isSuccess ? 'success-notification' : 'error-notification',
          closeOnClick: true,
          closeTimeout: 3000
        }).open()
      },
      async getCode () {
        this.showLoader()
        this.UserCode = null
        let payload = {
          userEmail: this.currentUserEmail,
          subscriptionId: this.AppConfig.Subscription_Id,
          UserName: this.AppConfig.AppName,
          language : this.language,
          UserImage: this.AppConfig.Urls.ContentAssetsBaseUrl+ '00-app-icon.png'
        }
        let isSusscess = true
        let msg = await this.checkEmailExists(payload)
        if (this.isLogin) {
          if (typeof(msg) === 'undefined') {
            isSusscess = false
            this.showAlert(this.resource.noInternetAccess, '', false)
          } else {
            if (msg === 'NOTEXISTS') {
              isSusscess = false
              this.showAlert(this.resource.userNotExists, this.resource.userDiffEmail, false)
            } else if (msg === 'BLOCKED') {
              isSusscess = false
              this.showAlert(this.resource.loginBlockMsg, '', false)
            }
          }
        } else {
          if (typeof(msg) === 'undefined') {
            isSusscess = false
            this.showAlert(this.resource.noInternetAccess, '', false)
          } else {
            if (msg === 'EXISTS') {
              isSusscess = false
              this.showAlert(this.resource.userAlrdyExists, this.resource.userDiffEmail, false)
            } else if (msg === 'BLOCKED') {
              isSusscess = false
              this.showAlert(this.resource.loginBlockMsg, '', false)
            }
          }
        }
        if (isSusscess) {
          this.codeToVerify = await this.getVerificationCode(payload)
          if (isNaN(this.codeToVerify)) {
            if (typeof(this.codeToVerify) === 'undefined') {
              this.showAlert(this.resource.noInternetAccess, '', false)
            } else {
              this.showAlert(this.resource.invalidEmailMsg, this.resource.userDiffEmail, false)
            }
          } else {
            this.sentcode = true
            this.Emaildisable = true
            this.showAlert(this.resource.sentCode, this.resource.codeSendSuccessMsg + this.currentUserEmail, true)
          }
        }
        this.hideLoader()
      },
      async verifyCode () {
        let IsLoggin = this.isRegistred
         if (parseInt(this.codeToVerify) === parseInt(this.UserCode)) {
            let isSuccess = await this.saveUser()
            if (isSuccess) {
              this.setUserId()
              this.setUserInfo(this.UserToVerify)
              this.showAlert(this.resource.succesTitle, IsLoggin ? this.resource.loginsuccesMessage : this.resource.succesMessage, true)
              this.clearFlag()
              this.$refs.userregistrationpopup.close()
            }
         } else {
           this.UserCode = null
           if(this.$refs.inptCode) {
             this.$refs.inptCode.$el.childNodes[0].focus()
           }
           this.showAlert(this.resource.codeErrorMsg, this.resource.codeResendMsg, false)
         }
      },
      async saveUser () {
        let isSuccess = true
        this.showLoader()
        this.UserName = this.currentUserName
        this.UserEmail = this.currentUserEmail
        if (isPhoneGap()) {
          if (this.uploadedbase64) {
            let res = await this.uploadImage(this.uploadedbase64, this.imgHeight, this.imgWeight)
            if (typeof(res) === 'undefined') {
              isSuccess = false
              this.hideLoader()
              this.showAlert(this.resource.noInternetAccess, '', false)
            }
          }
        }
        if (isSuccess) {
          let userInfo = this.getUserObj()
          if (!this.isRegistred) {
            userInfo.id = Helper.CreateGUID()
          }
          await this.insertUser(userInfo).then(async (response) => {
            if (typeof(response) === 'undefined') {
              isSuccess = false
              this.showAlert(this.resource.noInternetAccess, '', false)
            } else {
              if (response != null) {
                this.UserToVerify = response
                this.isRegistred = true
              }
            }
            this.hideLoader()
          }).catch(err => {
            console.log('get err', err)
            this.hideLoader() 
            isSuccess = false
          })
        }
        return isSuccess
      },
      setUserId () {
        window.localStorage.setItem('chatUserId' + this.AppConfig.Subscription_Id, this.UserToVerify.id)
      },
      getUserObj () {
        return {
          userName : this.ChatsUser.userName,
          userEmail : this.ChatsUser.userEmail,
          userImage : this.ChatsUser.userImage,
          subscriptionId: this.AppConfig.Subscription_Id,
          deviceId: isPhoneGap() ? Helper.getNotifyDeviceId() : '',
          deviceType: DeviceInfo.isAndroid ? 'ANDROID' : (DeviceInfo.isIOS ? 'IOS': 'WEBAPP')
        }
      },
      getNameValidationMsg () {
        let message = ''
        if (Helper.IsNullOrEmpty(this.currentUserName)) {
          message += this.resource.errorCommentMessageName + '<br/>'
        }
        return message
      },
      getEmailValidationMsg () {
        let message = ''
        if (Helper.IsNullOrEmpty(this.currentUserEmail)) {
          message += this.resource.errorCommentMessageEmail + '<br/>'
        } else if (!Helper.validateEmail(this.currentUserEmail)) {
          message += this.resource.errorCommentMessageValidEmail + '<br/>'
        }
        return message
      },
      getValidationMsg () {
        let message = this.getNameValidationMsg()
        message += this.getEmailValidationMsg()
        return message
      },
      clearFlag() {
       this.isRegistred = false
       this.isLogin = false
       this.inputDisabled = false
       this.Emaildisable = false
       this.sentcode= false
       this.counter= 60
       this.currentUserName = this.UserName
       this.currentUserEmail = this.UserEmail
       this.currentUserImage = this.UserImage
       this.UserCode = null
       this.resetImgVariables()
     },
     alreadyRegistred() {
      this.timeLeft = '00:00'
      this.isRegistred = true,
      this.currentUserEmail = ''
     },
     resetImgVariables () {
       this.dataURL = ''
       this.imgWeight = ''
       this.imgHeight = ''
       this.uploadedbase64 = ''
     }
    }
  }
  function zeroPadded(num) {
    // 4 --> 04
    return num < 10 ? `0${num}` : num;
  }
  function hourConvert(hour) {
    // 15 --> 3
    return (hour % 12) || 12;
  }
  
</script>
<template>
  <f7-popup id="user-registration-popup" ref="userregistrationpopup" class="user-registration-popup" tablet-fullscreen>
    <f7-page :page-content="false">
      <f7-navbar>
        <f7-nav-left>
          <f7-link class="closebtnlbl" @click="clearFlag()" popup-close>{{resource.closeBtn}}</f7-link>
        </f7-nav-left>
        <f7-nav-title>{{resource.registrationTitle}}</f7-nav-title>
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <div class="backgroundimg"></div>
      <f7-page-content>
        <div v-if="!sentcode && !isRegistred" class="user-top">
          <div class="user-thumb">    
            <span  class="user-register-avatar" :style="'background-image: url('+ getStyle(dataURL) +')'">
            </span>  
            <div class="fab fab-right-bottom fab-custom" id="speedDial">
              <a raised @click="actionGridOpened = true" href="#">
                <i class="icon f7-icons">add</i>
              </a>             
            </div>
          </div>      
        </div>
        <f7-actions :grid="true" :opened="actionGridOpened" @actions:closed="actionGridOpened = false">
          <f7-actions-group>
            <f7-actions-button @click="getPicture('CAMERA')">
              <img slot="media" :src="MediaUrlCamera" width="47"/>
              <span>Camera</span>
            </f7-actions-button>
            <f7-actions-button @click="getPicture('PHOTOLIBRARY')">
              <img slot="media" :src="MediaUrlPhotoLib" width="47"/>
              <span>Gallery</span>
            </f7-actions-button>
            <f7-actions-button @click="removeImage()">
              <img slot="media" :src="MediaUrlBin" width="47"/>
              <span>Delete</span>
            </f7-actions-button>
          </f7-actions-group>    
        </f7-actions>  
        <f7-list v-if="!sentcode && !isRegistred" class="inputs-list">
          <f7-list-item class="input-wrapper">
            <f7-label class="label-color">{{resource.nameLbl}}</f7-label>
            <f7-input :value="currentUserName" @input="currentUserName = $event.target.value" type="text" :placeholder="resource.nameLbl" :maxlength="40"/>
          </f7-list-item>
        </f7-list>
        <f7-list  class="inputs-list">
          <f7-list-item class="input-wrapper">
            <f7-label class="label-color">{{resource.emailLbl}}</f7-label>
            <f7-input :disabled="Emaildisable" :value="currentUserEmail" @input="currentUserEmail = $event.target.value" type="email" :placeholder="resource.emailLbl"></f7-input>
          </f7-list-item>
        </f7-list>
        <f7-list v-if="sentcode" class="inputs-list">
          <f7-list-item class="input-wrapper">
            <f7-label class="label-color">{{resource.enterCodeMsg}}</f7-label>
            <f7-input ref="inptCode"  type="text" pattern="^[0-9]*$" :value="UserCode" @input="UserCode = $event.target.value" onkeypress="return /[0-9]/i.test(event.key)"></f7-input>
          </f7-list-item>
        </f7-list>
        <f7-block>
          <f7-button  v-if="!sentcode && !isRegistred"  big fill @click="register()">{{resource.registrationBtn}}</f7-button>      
        </f7-block>
        <f7-block v-if="!sentcode && isRegistred" >
          <f7-row>
            <f7-col>
               <f7-button  big fill @click="login()">{{resource.sendCodeBtn}}</f7-button>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block v-if="sentcode">
          <f7-row>
            <f7-col>
               <f7-button ref="btnVerify"  big fill @click="verifyCode()">{{resource.verifyBtn}}</f7-button>
            </f7-col>
            <f7-col>
              <f7-button :disabled="!inputDisabled" big fill @click="ResendCode()">{{timeLeft}}</f7-button>
            </f7-col>
          </f7-row>
        </f7-block>
         <f7-block>
           <f7-button v-if="isRegistred" big fill @click="clearFlag()">{{resource.backToRegisterBtn}}</f7-button>
         </f7-block>
        <f7-block>
          <f7-button v-if="!sentcode && !isRegistred" big fill @click="alreadyRegistred()">{{resource.alreadyRgstrBtn}}</f7-button>
        </f7-block>
      </f7-page-content>
    </f7-page>
  </f7-popup>
</template>
<style scoped>
  .closebtnlbl {
  font-size: 14px ;
  }
  .user-register-avatar {
    min-width: 30vw;
    min-height: 30vw;
    background-repeat: no-repeat;
    background-size: cover !important;
    display: inline-block;
    margin: 10px;
    /* float: left;    */
    /* margin-top: 20px;
    margin-left: 160px; */
    vertical-align: middle;
    border-radius: 100%;
    background-position: center;
  }
  .user-image {
    height: 20vw;
    width: 20vw;
    border-radius: 40vw;
  }
  .user-top{
    position: relative;
  }
  .user-top .fab{
    bottom: 20px!important;
    right: 36%;
  }
  .user-thumb{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-top .fab a{
    width: 25px;
    height: 25px;
  }
  .user-top i.icon {
    font-size: 17px;
}
.list .item-title {
  padding-bottom: 1px;
}

.navbar .title {
  padding-bottom:2px;
}
.md .item-input-wrap:after {
  background-color: transparent;
}
.md .theme-onAirDefault .item-input-focused .item-input-wrap:after {
  background:transparent;
}
  /* min-height: 40px; */
</style>



// WEBPACK FOOTER //
// src/components/shared/UserRegistration.vue